/* La barra de arriba de cualquier listado: buscar, filtrar, y —desde ahora—
 * AGREGAR.
 *
 * ── EL BOTÓN DE AGREGAR ESTABA DEBAJO DE LA TABLA ────────────────────────
 *
 * Y con 679 furgones eso son 679 filas de distancia: para dar de alta uno
 * había que bajar el listado entero. En la pantalla no se veía —quedaba
 * cortado por el borde de la ventana— así que la lectura obvia era que no se
 * podía agregar desde el padrón.
 *
 * Es la misma falla que ya tuvimos tres veces con otra forma: el botón de la
 * planilla en `/documentos` de FlotaBot, `/api/sync-docs` sin botón, y la
 * agenda de turnos sin puerta desde el RTO de furgones. **Un botón que no está
 * donde se hace el trabajo es lo mismo que no estar** — sólo que éste encima
 * existía y se veía a medias, que es peor: se ve el borde de algo y no se sabe
 * qué es.
 *
 * Va arriba a la derecha, en la misma línea que el buscador, que es donde ya
 * está el resto de la acción de la pantalla. */
const FiltrosBar = ({
  textoFiltro,
  setTextoFiltro,
  facetas,
  filtroSelect,
  setSelect,
  filtroScope,
  toggleScope,
  hayFiltrosActivos,
  limpiarFiltros,
  cuenta = null,
  onAgregar = null,
  textoAgregar = "Agregar",
}) => {
  const selects = facetas.filter((col) => col.modo === "select");
  const chips = facetas.filter((col) => col.modo === "scope");

  return (
    <div className="filtros-bar">
      <div className="filtros-bar__top">
        <input
          className="filtros-bar__busqueda"
          placeholder="Buscar..."
          value={textoFiltro}
          onChange={(e) => setTextoFiltro(e.target.value)}
        />
        {cuenta && <span className="table-cuenta">{cuenta}</span>}
        {hayFiltrosActivos && (
          <button
            type="button"
            className="link-button filtros-bar__limpiar"
            onClick={limpiarFiltros}
          >
            Limpiar filtros
          </button>
        )}
        {/* ÚLTIMO EN EL RENGLÓN Y PRIMERO EN IMPORTANCIA. Va después del
            buscador porque agregar es lo que menos se hace —se entra a mirar,
            se busca, y de vez en cuando se carga— pero tiene que estar EN la
            primera pantalla: abajo de la tabla no existe.

            Dice «Agregar furgón» y no «AGREGAR» a secas: el listado se abre
            desde ocho padrones distintos y desde adentro de otras pantallas, y
            un botón que sólo dice el verbo obliga a mirar el título para saber
            qué va a crear. */}
        {onAgregar && (
          <button
            type="button"
            className="btn-primario filtros-bar__agregar"
            onClick={onAgregar}
          >
            + {textoAgregar}
          </button>
        )}
      </div>

      {facetas.length > 0 && (
        <div className="filtros-bar__facetas">
          {selects.map((col) => (
            <label key={col.key} className="filtro-select">
              <span className="filtro-select__label">{col.label}</span>
              <select
                value={filtroSelect[col.key] || ""}
                onChange={(e) => setSelect(col.key, e.target.value)}
              >
                <option value="">Todos</option>
                {col.opciones.map((op) => (
                  <option key={op} value={op}>
                    {op}
                  </option>
                ))}
              </select>
            </label>
          ))}

          {/* Columnas de identificador (nro de evento, dominio, legajo):
              tienen demasiados valores para un desplegable, así que en
              vez de elegir uno se acota dónde busca el texto de arriba.
              Antes era un checkbox que decía "Buscar solo en Nro Evento";
              eso explicaba cómo funciona el buscador por dentro. */}
          {chips.length > 0 && (
            <>
              <span className="filtros-bar__chips-label">Buscar en</span>
              {chips.map((col) => (
                <button
                  key={col.key}
                  type="button"
                  className="filtro-chip"
                  aria-pressed={!!filtroScope[col.key]}
                  onClick={() => toggleScope(col.key)}
                >
                  {col.label}
                </button>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default FiltrosBar;
